import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { DoraFunction } from '../../models/doraFunction.ts';

interface DoraFunctionState {
  doraFunctions: DoraFunction[];
  selectedDoraFunction: DoraFunction | null;
  loading: boolean;
  error: string | null;
}

const initialState: DoraFunctionState = {
  doraFunctions: [],
  selectedDoraFunction: null,
  loading: false,
  error: null,
};

const doraFunctionSlice = createSlice({
  name: 'doraFunction',
  initialState,
  reducers: {
    setDoraFunctions(state, action: PayloadAction<DoraFunction[]>) {
      state.doraFunctions = action.payload;
    },
    addDoraFunction(state, action: PayloadAction<DoraFunction>) {
      state.doraFunctions.push(action.payload);
    },
    updateDoraFunction(state, action: PayloadAction<DoraFunction>) {
      const index = state.doraFunctions.findIndex(func => func.id === action.payload.id);
      if (index !== -1) state.doraFunctions[index] = action.payload;
    },
    removeDoraFunction(state, action: PayloadAction<number>) {
      state.doraFunctions = state.doraFunctions.filter(func => func.id !== action.payload);
    },
    setSelectedDoraFunction(state, action: PayloadAction<DoraFunction | null>) {
      state.selectedDoraFunction = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setDoraFunctions,
  addDoraFunction,
  updateDoraFunction,
  removeDoraFunction,
  setSelectedDoraFunction,
  setLoading,
  setError,
} = doraFunctionSlice.actions;

export const selectDoraFunctions = (state: RootState) => state.doraFunction.doraFunctions;
export const selectSelectedDoraFunction = (state: RootState) => state.doraFunction.selectedDoraFunction;
export const selectFunctionLoading = (state: RootState) => state.doraFunction.loading;
export const selectFunctionError = (state: RootState) => state.doraFunction.error;

export default doraFunctionSlice.reducer;
